<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable" style="border:0;">
            <ng-container *ngFor="let plant of plants">
                <tr style="height:22px;">
                    <td style="width: 10em"><b>Plant Type:</b></td>
                    <td style="padding-left:5px;">{{plant.plantType}}</td>
                    <td rowspan="4">
                        <div *ngIf="plant.productionUnits.length > 0" style="width:45%;float:left;margin:5px;">
                            <b>Production Units</b>
                            <ul *ngFor="let productionUnit of plant.productionUnits"
                                style="list-style:none;margin-bottom:0px;">
                                {{productionUnit.productionUnitType}}
                            </ul>
                        </div>
                        <div *ngIf="plant.materials.length > 0" style="width:45%;float:left;margin:5px;">
                            <b>Products</b>
                            <ul *ngFor="let material of plant.materials"
                                style="list-style:none;margin-bottom:0px;width:50%;float:left;">
                                {{material.material}}
                            </ul>
                        </div>
                        <div style="clear:both;"></div>
                    </td>
                </tr>
                <tr *ngIf="!plant.dailyProcessCapacity" style="border:0;"></tr>
                <tr *ngIf="plant.dailyProcessCapacity" style="height:22px;">
                    <td><b>Daily Capacity:</b></td>
                    <td style="text-align:right;padding-right:5px;">
                        {{plant.dailyProcessCapacity | number}}
                        <span style="width:2em;display:inline-block;text-align:left;">b/d</span>
                    </td>
                </tr>
                <tr *ngIf="!plant.annualProcessCapacity" style="border:0;"></tr>
                <tr *ngIf="plant.annualProcessCapacity" style="height:22px;">
                    <td><b>Annual Capacity:</b></td>
                    <td style="text-align:right;padding-right:5px;">
                        {{plant.annualProcessCapacity | number}}
                        <span style="width:2em;display:inline-block;text-align:left;">mtpa</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                </tr>
                <tr>
                    <td colspan="3" style="height:10px;border-left:0;border-right:0;border-bottom:0;"></td>
                </tr>
            </ng-container>
        </table>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid">
        <h5>{{title}}</h5>
        <table class="optionalComponentSectionTable" style="border:0;">
            <ng-container *ngFor="let plant of plants">
                <tr style="height:22px;">
                    <td style="width: 10em"><b>Plant Type:</b></td>
                    <td style="padding-left:5px;">{{plant.plantType}}</td>
                    <td rowspan="4">
                        <div *ngIf="plant.productionUnits.length > 0" style="width:45%;float:left;margin:5px;">
                            <b>Production Units</b>
                            <ul *ngFor="let productionUnit of plant.productionUnits"
                                style="list-style:none;margin-bottom:0px;">
                                {{productionUnit.productionUnitType}}
                            </ul>
                        </div>
                        <div *ngIf="plant.materials.length > 0" style="width:45%;float:left;margin:5px;">
                            <b>Products</b>
                            <ul *ngFor="let material of plant.materials"
                                style="list-style:none;margin-bottom:0px;width:50%;float:left;">
                                {{material.material}}
                            </ul>
                        </div>
                        <div style="clear:both;"></div>
                        {{plant}}
                    </td>
                </tr>
                <tr *ngIf="!plant.dailyProcessCapacity" style="border:0;"></tr> <!--*ngIf="plant.dailyProcessCapacity ==0"-->
                <tr *ngIf="plant.dailyProcessCapacity" style="height:22px;"> <!--*ngIf="plant.dailyProcessCapacity>0"-->
                    <td><b>Daily Capacity:</b></td>
                    <td style="text-align:right;padding-right:5px;">
                        {{plant.dailyProcessCapacity | number}}
                        <span style="width:2em;display:inline-block;text-align:left;">b/d / boe</span>
                    </td>
                </tr>
                <tr *ngIf="!plant.annualProcessCapacity" style="border:0;"></tr>
                <tr *ngIf="plant.annualProcessCapacity" style="height:22px;">
                    <td><b>Annual Capacity:</b></td>
                    <td style="text-align:right;padding-right:5px;">
                        {{plant.annualProcessCapacity | number}}
                        <span style="width:2em;display:inline-block;text-align:left;">mtpa</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2"></td>
                </tr>
                <tr>
                    <td colspan="3" style="height:10px;border-left:0;border-right:0;border-bottom:0;"></td>
                </tr>
            </ng-container>

        </table>
    </div>
</ng-template>